import * as React from 'react';
import tombacIcon from '../tombacIcon';

function SvgLimitsArea(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="4 -4 16 24" {...props}>
      <path
        d="M20 0v16H4V0zm-2 2h-1.168L6 12.849V14h1.601L17.999 3.606V2zm0 4.435L10.424 14h2.719l4.855-4.844zm0 5.551L15.968 14H18zM14.006 2h-2.532L6 7.485v2.536zM8.649 2H6v2.656z"
        fill="currentColor"
      />
    </svg>
  );
}

export default tombacIcon('LimitsArea')(SvgLimitsArea);
